/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PurgeInputs */

const en_purge = /** @type {(inputs: PurgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purge`)
};

const id_purge = /** @type {(inputs: PurgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus Tuntas`)
};

/** @type {(inputs: PurgeInputs) => LocalizedString} */
const es_purge = en_purge;

/** @type {(inputs: PurgeInputs) => LocalizedString} */
const fr_purge = en_purge;

/** @type {(inputs: PurgeInputs) => LocalizedString} */
const de_purge = en_purge;

/** @type {(inputs: PurgeInputs) => LocalizedString} */
const ja_purge = en_purge;

/** @type {(inputs: PurgeInputs) => LocalizedString} */
const zh_purge = en_purge;

/** @type {(inputs: PurgeInputs) => LocalizedString} */
const ar_purge = en_purge;

/** @type {(inputs: PurgeInputs) => LocalizedString} */
const it_purge = en_purge;

/** @type {(inputs: PurgeInputs) => LocalizedString} */
const ru_purge = en_purge;

/** @type {(inputs: PurgeInputs) => LocalizedString} */
const pt_purge = en_purge;

/** @type {(inputs: PurgeInputs) => LocalizedString} */
const ko_purge = en_purge;

/**
* | output |
* | --- |
* | "Purge" |
*
* @param {PurgeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const purge = /** @type {((inputs?: PurgeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PurgeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_purge(inputs)
	if (locale === "es") return es_purge(inputs)
	if (locale === "fr") return fr_purge(inputs)
	if (locale === "de") return de_purge(inputs)
	if (locale === "ja") return ja_purge(inputs)
	if (locale === "zh") return zh_purge(inputs)
	if (locale === "ar") return ar_purge(inputs)
	if (locale === "id") return id_purge(inputs)
	if (locale === "it") return it_purge(inputs)
	if (locale === "ru") return ru_purge(inputs)
	if (locale === "pt") return pt_purge(inputs)
	return ko_purge(inputs)
});